.emojiPicker > div em-emoji-picker {
  --border-radius: 0px;
  --background-rgb: var(--picker-background-rgb);
  --rgb-background: var(--picker-background-rgb);
  --rgb-color: var(--picker-text-rgb);
  --rgb-accent: var(--picker-accent-rgb);
  --rgb-input: var(--picker-selected-input-bg-rgb);
  --color-border: var(--picker-border-and-hover-color);
  --font-family: var(--font-family);
  --color-border-over: rgba(0, 0, 0, 0);
  --shadow: none;
}
.emojiPicker.full > div {
  width: 100%;
  height: 100%;
}
.emojiPicker.full > div em-emoji-picker {
  width: 100%;
  height: 100%;
}